import { Pipe, PipeTransform } from '@angular/core';
import { compareDate } from '@frontend/unhideschool/app/helpers/utility-functions';
import { MembershipAccess } from '@frontend/unhideschool/modules/membership/membership-subscription.selectors';

@Pipe({name: 'compareDate'})
export class CompareDatePipe implements PipeTransform {
    transform(membershipAccess: MembershipAccess): boolean {
        return compareDate(membershipAccess?.userentitlement?.validuntil);
    }
}
